// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";

export const REQUEST_FORM_DATA = "REQUEST_FORM_DATA";
export const RECEIVE_FORM_DATA = "RECEIVE_FORM_DATA";
export const RECEIVE_ERROR_FORM_DATA = "RECEIVE_ERROR_FORM_DATA";

function requestFormData() {
  return {
    type: REQUEST_FORM_DATA
  };
}

function receiveFormData(formData) {
  return {
    type: RECEIVE_FORM_DATA,
    formData
  };
}

function receiveFormDataError(message) {
  return {
    type: RECEIVE_ERROR_FORM_DATA,
    message
  };
}

export function fetchFormData(uuid) {
  return dispatch => {
    dispatch(requestFormData());
    return window
      .fetch(`/public/formData/${uuid}`)
      .then(resp => resp.json(), error => error)
      .then(json => {
        if (json.error) {
          dispatch(receiveFormDataError(json.error));
        }
        dispatch(receiveFormData(json));
      });
  };
}
